import React, { useState, useEffect } from 'react';

import BackgroundImage from '../BackgroundImage';

import { getPlayerNumber, checkIfPlayerWon } from '../../utils/postScore';
import { getClickAttrs } from '../Analytics/gtag';

const Player = (props) => {
    const {
        match,
        isDualMatch,
        isDoubles,
        isEditable,
        playerPost,
        position,
        isReverseView,
        isWinner,
        winningTeam,
        matchOutCome,
        isInPopup,
    } = props;

    const [baseURl, setBaseURl] = useState(null);
    const [images, setImages] = useState(null);

    useEffect(() => {
        if (match && match[position]) {
            setBaseURl(isDualMatch ? '/v1/club/' : '/v1/player/');
            setImages(isDualMatch ? match[position].clubProfileImages : match[position].playerProfileImages);
        } else {
            setBaseURl(null);
            setImages(null);
        }
    }, [match, isDualMatch]);

    const matchPositionExists = match && match[position];
    const playerNumber = getPlayerNumber({ position, winningTeam, matchOutCome, isReverseView, isDoubles });
    const [number, status] = playerNumber.split('-').map(s => s.trim());
    const popupClassName = isDoubles ? `col-md-6` : `col-md-8 offset-md-2 `;
    const className = `col-md-6 ${isDoubles ? '' : 'offset-md-3'}`;

    return (
        <div className={`${isInPopup ? popupClassName : className}`}>
            <div
                className={`ps-player-card d-flex ${matchPositionExists ? '' : 'add-player'} ${props.round ? '' : 'clickable'}`}
                data-testid={`post-score.player-card-${position}`}
                onClick={() => {
                    // dont allow for player posting for player1
                    if (isEditable && !(playerPost && position === 'player1')) {
                        props.addPlayer(position, isDoubles);
                    }
                }}
                {...getClickAttrs({
                    category: 'Post Score',
                    context: 'Add Player',
                    location: 'Post Score Form',
                })}
            >
                {matchPositionExists ? (
                    <BackgroundImage
                        baseUrl={baseURl}
                        images={images}
                        imageType={'icon'}
                        parentStylesClass={'avatar'}
                        defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                    />
                ) : (
                    <div className="avatar" />
                )}
                <div className="player-details">
                    <div className={`player-name h6 ${matchPositionExists ? 'd-none' : 'd-block'}`} data-testid="post-score.add-player">
                        Add Player
                    </div>
                    {matchPositionExists && (
                        <div className="player-name h6">
                            {(match[position].firstName).split(' ')[0]}
                            &nbsp;
                            {(match[position].lastName).split(' ')[0]}
                        </div>
                    )}
                    <div className={`player-number`}>
                        {number}
                        &nbsp;
                        {status && (
                            <>
                                <span>-</span>&nbsp;
                                <span className={`uppercase fw600 ${checkIfPlayerWon({ position, isWinner, winningTeam }) ? 'winner' : ''}`}>
                                    {status}
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Player;
